<template>
  <div>
    <v-row>
      <v-col class="text-center">
        <v-dialog v-model="dialog" persistent max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline"></span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Route Name*"
                      v-model="name"
                      required
                      hint="Make sure it's easy to remember"
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12">
                    <v-select
                      v-if="accessFrom == 'mainroute'"
                      :items="allUsersByOffice"
                      label="Assign To"
                      item-value="id"
                      class="added-receiver"
                      v-model="user"
                      return-object
                    >
                      <template slot="selection" slot-scope="{ item }">
                        {{ item.user_name }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <v-list-item-content>
                          <p class="fullName">
                            {{ item.name }} -
                            <span class="primary--text">{{
                              item.user_name
                            }}</span>
                          </p>
                        </v-list-item-content>
                      </template>
                    </v-select>
                    <v-select
                      v-else
                      :items="allUsers"
                      label="Select Receiver"
                      item-value="item"
                      class="added-receiver"
                      v-model="user"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.first_name }}
                        {{ item.middle_name }}
                        {{ item.last_name }}

                        <span class="blue--text ml-2">
                          --
                          {{
                            item.positions[0]
                              ? item.positions[0].name
                              : " no position assigned "
                          }}
                        </span>
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.first_name }}
                        {{ item.middle_name }}
                        {{ item.last_name }}

                        <span class="blue--text ml-2">
                          --
                          {{
                            item.positions[0]
                              ? item.positions[0].name
                              : " no position assigned "
                          }}
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="allActions"
                      label="Select Action"
                      item-value="id"
                      class="added-action"
                      v-model="action"
                      @change="checkActionDue"
                      return-object
                    >
                      <template slot="selection" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                        <span v-if="item.hasDueDate" class="indigo--text ml-2">
                          -- due date enabled
                        </span>
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                        <span v-if="item.hasDueDate" class="indigo--text ml-2">
                          -- due date enabled
                        </span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" v-show="show_due_date">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="datetime_due"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="datetime_due"
                          v-model="computedDateTimeDue"
                          label="Action Due Date"
                          prepend-icon="mdi-calendar"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="datetime_due" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(datetime_due)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12">
                    <span class="body-1 mb-4">Add Instructions</span>
                    <ckeditor
                      :editor="editor"
                      v-model="instructions"
                      v-dompurify-html="instructions"
                      :config="editorConfig"
                    ></ckeditor>
                  </v-col>
                  <!-- <v-col cols="12">
                    <v-switch
                      v-model="sequence_number"
                      :label="`In Sequence: ${
                        sequence_number ? 'Assigned' : 'Not Assigned'
                      }`"
                    ></v-switch>
                  </v-col> -->
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">
                      {{ errorMessage }}
                    </h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="updateSave()"
                v-if="isUpdate"
                :disabled="disableSave"
                >Save</v-btn
              >
              <v-btn color="blue darken-1" text @click="add()" v-else
                >Add</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <ActionTemplatesDialog
      accessFrom="route"
      :dialog2="action_template_dialog"
      :action="selected_action"
      @closeDialog="closeActionStatus"
    />
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import Swal from "sweetalert2";
  import moment from "moment";
  import ActionTemplatesDialog from "./actions/ActionTemplatesDialog.vue";
  import LoadingOverlay from "./common/LoadingOverlay.vue";

  import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";

  import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
  import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
  import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
  import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
  import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
  import ChecklistPlugin from "@ckeditor/ckeditor5-list/src/todolist";

  export default {
    name: "AddReceiverModal",
    props: {
      dialog: Boolean,
      parentRoute: Number,
      parentRouteType: String,
      mainRoute: String,
      isUpdate: Boolean,
      updateReceiver: Object,
      initiatorDueDate: String,
      accessFrom: String,
      userAssigned: Number,
    },
    components: {
      ActionTemplatesDialog,
      LoadingOverlay
    },
    data() {
      return {
        disableSave: true, 
        loading: false,
        selected_action: null,
        action_template_dialog: false,
        instructions_details: "",
        instructions_list: [],
        name: "",
        user: null,
        action: null,
        sequence_number: false,
        errorMessage: null,
        datetime_due: this.initiatorDueDate,
        menu: false,
        instructions: "",
        editor: ClassicEditor,
        editorConfig: {
          plugins: [
            EssentialsPlugin,
            BoldPlugin,
            ItalicPlugin,
            ParagraphPlugin,
            ListPlugin,
            ChecklistPlugin,
          ],
          toolbar: {
            items: [
              "bold",
              "italic",
              "undo",
              "redo",
              "numberedList",
              "bulletedList",
            ],
          },
        },
        show_due_date: false,
        action_due_date: false,
        status_template: [],
      };
    },
    methods: {
      ...mapActions([
        "addUser",
        "removeUser",
        "fetchUsers",
        "fetchActions",
        "addNewReceiver",
        "addSubRoute",
        "updateAddedReceiver",
        "fetchUsersInOffice",
        "fetchActionTemplate",
      ]),
      getStringfromHtml(html){
          var txt = document.createElement("textarea");
          txt.innerHTML = html;
          return txt.value;
      },  
      close() {
        this.name = "";
        this.sequence_number = false;
        this.user = null;
        this.action = null;
        this.errorMessage = null;
        this.datetime_due = this.initiatorDueDate;
        this.$emit("closeDialog", false);
        this.instructions_list = [];
        this.instructions = "";
        this.show_due_date = false;
      },
      validateName() {
        if (this.name == "") {
          this.errorMessage = "Name is required and not allowed to be empty";
          return false;
        }
        if (this.name.length < 4) {
          this.errorMessage = "Name must have a minimum of 4 characters";
          return false;
        }
        if (this.name.length > 40) {
          this.errorMessage = "Name must have a maximum of 40 characters";
          return false;
        }
        return true;
      },
      async add() {
        this.errorMessage = null;
        let body = {
          user: this.user,
          action: this.action,
          sequence_number: this.sequence_number,
          // name: this.name,
          datetime_due: this.action_due_date
            ? this.datetime_due
            : this.initiatorDueDate,
          instructions: this.instructions,
          instructions_list: this.instructions_list,
          hasActionDueDate: this.action_due_date,
          status_template: this.status_template,
        };
        let added_route;
        if (!this.parentRoute) {
          // This is for adding routes to routes that haven't been created yet
          added_route = await this.addNewReceiver(body);
        } else {
          this.loading = true;
          body.route_id = this.mainRoute;
          added_route = await this.addSubRoute({
            data: body,
            parent_id:
              this.parentRouteType == "subroute" ? this.parentRoute : null,
            parent_type:
              this.parentRouteType == "subroute" ? "subroute" : "mainroute",
          });
        }

        if (added_route.error) {
          this.loading = false;
          if (added_route.status == "400")
            this.errorMessage = added_route.message;
          else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Internal Server Error",
            });
            this.close();
          }
        } else {
          this.loading = false;
          if (this.parentRoute) {
            Swal.fire("Saved!", "Added Sub Route", "success");
            this.close();
          } else this.close();
        }
      },
      updateSave() {
        const body = {
          datetime_due: this.action_due_date
            ? this.datetime_due
            : this.initiatorDueDate,
          user: this.user,
          selected: this.updateReceiver,
          action: this.action,
          instructions: this.instructions,
          instructions_list: this.instructions_list,
          hasActionDueDate: this.action_due_date,
          status_template: this.status_template,
        };
        this.updateAddedReceiver(body).then(() => {
          this.close();
        });
      },
      addInstructions() {
        if (
          this.instructions_details != "" &&
          this.instructions_details != " "
        ) {
          const body = {
            details: this.instructions_details,
            isDone: false,
          };
          this.instructions_list.push(body);
          this.instructions_details = "";
        }
      },
      checkActionDue() {
        this.disableSave = true
        if (this.action) {
          this.selected_action = this.action;
          this.action_template_dialog = true;
          if (this.action.hasDueDate) {
            this.show_due_date = true;
            this.action_due_date = true;
          } else {
            this.show_due_date = false;
            this.action_due_date = false;
          }
        }
      },
      closeActionStatus(val) {
        this.action_template_dialog = false;
        this.status_template = val;
        this.disableSave = false
      },
    },
    computed: {
      ...mapGetters([
        "getAssignedUsers",
        "getUnassignedUsers",
        "allUsers",
        "allActions",
        "allUsersByOffice",
        "allActionTemplates",
      ]),
      computedInstructionsList() {
        return this.instructions_list;
      },
      computedDateTimeDue() {
        return moment(new Date(this.datetime_due)).format("dddd, MMMM DD YYYY");
      },
    },
    created() {
      this.fetchActions({ bypass: true, limit: 0 });
    },
    watch: {
      dialog: function() {
        if (this.dialog) {
          this.disableSave = true
          if (this.accessFrom == "mainroute") {
            // this.fetchUsersInOffice({ itemsPerPage: 0 });
          } else {
            if (this.allUsers.length < 1) {
              this.fetchUsers({
                filter: this.userAssigned,
                itemsPerPage: 0,
              });
            }
          }

          if (this.isUpdate) {
            this.name = this.updateReceiver.name;
            this.datetime_due = this.updateReceiver.datetime_due;

            if (this.updateReceiver.hasActionDueDate) {
              this.action_due_date = true;
              this.datetime_due = this.updateReceiver.datetime_due;
              this.show_due_date = true;
            } else {
              this.action_due_date = false;
              this.show_due_date = false;
              this.datetime_due = this.initiatorDueDate;
            }

            this.action_due_date = this.updateReceiver.hasActionDueDate
              ? true
              : false;

            if (this.updateReceiver.action) {
              this.action = this.updateReceiver.action;
            }

            if (this.updateReceiver.instructions) {
              this.instructions = this.getStringfromHtml(this.updateReceiver.instructions);
            }

            if (
              this.updateReceiver.instructions_list &&
              this.updateReceiver.instructions_list.length > 0
            ) {
              this.instructions_list = this.updateReceiver.instructions_list;
            }

            if (this.accessFrom == "mainroute") {
              this.allUsersByOffice.forEach(element => {
                if (element.user_id == this.updateReceiver.user.id) {
                  this.user = element;
                  return;
                }
              });
            } else {
              this.allUsers.forEach(element => {
                if (element.id == this.updateReceiver.user.id) {
                  this.user = element;
                  return;
                }
              });
            }
          } else {
            this.datetime_due = this.initiatorDueDate;
          }
        }
      },
    },
    mounted() {
      // this.fetchActionTemplate();
    },
  };
</script>

<style></style>
